import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (_ctx.modalState?.component)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-wrapper",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleCloseModal && $options.handleCloseModal(...args)), ["self"]))
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalState.component), _normalizeProps(_guardReactiveProps(_ctx.modalState.props)), null, 16 /* FULL_PROPS */))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}